import { gql } from "@apollo/client";
import client from "../apolloClient";
import {
  PiOtaRelease,
  PiOtaReleaseListResult,
  UploadPiOtaReleasePayload,
} from "../../schemas/piOtaReleaseSchema";

const RELEASE_FRAGMENT = `
  id
  version
  sha256
  sizeBytes
  releaseNotes
  isActive
  createdBy
  createdAt
  updatedAt
`;

const LIST_PI_OTA_RELEASES = gql`
  query PiOtaReleases {
    piOtaReleases {
      releases {
        ${RELEASE_FRAGMENT}
      }
    }
  }
`;

const UPLOAD_PI_OTA_RELEASE = gql`
  mutation UploadPiOtaRelease($input: UploadPiOtaReleaseInput!) {
    uploadPiOtaRelease(input: $input) {
      ${RELEASE_FRAGMENT}
    }
  }
`;

const ACTIVATE_PI_OTA_RELEASE = gql`
  mutation ActivatePiOtaRelease($id: ID!) {
    activatePiOtaRelease(id: $id)
  }
`;

const DELETE_PI_OTA_RELEASE = gql`
  mutation DeletePiOtaRelease($id: ID!) {
    deletePiOtaRelease(id: $id)
  }
`;

export const piOtaReleaseService = {
  list: async (): Promise<PiOtaReleaseListResult> => {
    const { data } = await client.query({
      query: LIST_PI_OTA_RELEASES,
      fetchPolicy: "network-only",
    });
    return data.piOtaReleases;
  },

  upload: async (
    payload: UploadPiOtaReleasePayload
  ): Promise<PiOtaRelease> => {
    const { data } = await client.mutate({
      mutation: UPLOAD_PI_OTA_RELEASE,
      variables: { input: payload.input },
      context: {
        headers: { "Apollo-Require-Preflight": "true" },
      },
    });
    return data.uploadPiOtaRelease;
  },

  activate: async (id: string): Promise<boolean> => {
    const { data } = await client.mutate({
      mutation: ACTIVATE_PI_OTA_RELEASE,
      variables: { id },
    });
    return data.activatePiOtaRelease;
  },

  remove: async (id: string): Promise<boolean> => {
    const { data } = await client.mutate({
      mutation: DELETE_PI_OTA_RELEASE,
      variables: { id },
    });
    return data.deletePiOtaRelease;
  },
};
